import { useDispatch } from "react-redux";

import useCurrentUser from "data/advisor/useCurrentUser";
import useHub from "data/hub/useHub";

import { OpenConnectCrmModal } from "scenes/Hubly/components/HubModals/components/ConnectCRMModal/actions";

const allIntegrationApps = [
  {
    name: "redtail",
    options: [
      {
        content: "Product Overview",
        icon: "external alternate",
        key: "product-overview",
        onClick: () => {
          const win = window.open(
            "https://corporate.redtailtechnology.com/crm/",
            "_blank"
          );
          win.focus();
        },
      },
    ],
  },
  {
    name: "wealthbox",
    options: [
      {
        content: "Product Tours",
        icon: "external alternate",
        key: "product-tours",
        onClick: () => {
          const win = window.open(
            "https://www.wealthbox.com/product-tours/",
            "_blank"
          );
          win.focus();
        },
      },
    ],
  },
  {
    name: "salesforce",
    options: [
      {
        content: "Product Overview",
        icon: "external alternate",
        key: "product-overview",
        onClick: () => {
          const win = window.open("https://salesforce.com/", "_blank");
          win.focus();
        },
      },
    ],
  },
  {
    name: "zapier",
    onClick: () => {
      let url =
        "https://zapier.com/developer/public-invite/48312/fce428e2ff2a7e8f9901be052fb46923/"; // zapier prod URL

      if (
        process.env.REACT_APP_STAGE === "dev" ||
        process.env.REACT_APP_STAGE === "local"
      ) {
        url =
          "https://zapier.com/developer/public-invite/48309/127fa230526bcad8122253c7d5acf48a/"; // zapier dev URL
      } else if (process.env.REACT_APP_STAGE === "pull-request") {
        url =
          "https://zapier.com/developer/public-invite/48311/9ff5a79a0a48d82f4e422a7227adb476/"; // zapier pull-request URL
      } else if (process.env.REACT_APP_STAGE === "staging") {
        url =
          "https://zapier.com/developer/public-invite/48308/886e6fff41e1241f13b18f18d5f05b55/"; // zapier staging URL
      }

      const win = window.open(url, "_blank");
      win.focus();
    },
    alwaysAvailable: true,
    options: [
      {
        content: "Documentation",
        icon: "external alternate",
        key: "documentation",
        onClick: () => {
          const win = window.open(
            "https://zapier.com/learn/getting-started-guide/",
            "_blank"
          );
          win.focus();
        },
      },
      {
        content: "Manage Connection",
        icon: "external alternate",
        key: "manage-connection",
        onClick: () => {
          const win = window.open(
            "https://zapier.com/app/connections",
            "_blank"
          );
          win.focus();
        },
      },
    ],
  },
];

function useUserIntegrationApps() {
  const user = useCurrentUser();
  const { id: selectedHubId } = useHub();
  const dispatch = useDispatch();

  const openConnectCrmModal = ({ name }) => {
    return () => {
      dispatch(OpenConnectCrmModal(name));
    };
  };

  const userAppTypes = user.integrations
    .filter(({ hubId }) => {
      return selectedHubId === hubId;
    })
    .map(({ type }) => {
      return type;
    });

  const connectedApps = allIntegrationApps
    .filter(({ name }) => {
      return userAppTypes.includes(name);
    })
    .map((props) => {
      return {
        ...props,
        onClick: props.onClick || openConnectCrmModal(props),
        connected: true,
        canConnect: true,
      };
    });

  const availableApps = allIntegrationApps
    .filter(({ name }) => {
      return !userAppTypes.includes(name);
    })
    .map((props) => {
      return {
        ...props,
        onClick: props.onClick || openConnectCrmModal(props),
        connected: false,
        canConnect: props.alwaysAvailable || userAppTypes.length === 0,
      };
    });

  return { connectedApps, availableApps };
}

export default useUserIntegrationApps;
